import { CalendarOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space } from 'antd';
import React from 'react';
import CustomDatePicker from '../components/CustomDatePicker';
import { filterConditions } from '../utils/filter-utils';
import { getAseguradoras, getPersonas, getProductos } from './api';

const { RangePicker } = CustomDatePicker;
export const getColumnDateSearchProps = (column) => {
  const sortProps = column.sortable ? getColumnSortBaseProps() : {};
  return {
    ...sortProps,
    filterCondition: filterConditions.EQUALS,
    filterDropdown: ({ setSelectedKeys, confirm }) => (
      <div style={{ padding: 8 }}>
        <CustomDatePicker
          onChange={(date, dateString) => {
            setSelectedKeys(dateString);
            confirm();
          }}
          format="YYYY-MM-DD"
        />
      </div>
    ),
    filterIcon: (filtered) => (
      <CalendarOutlined
        style={{
          color: filtered ? '@primary-color' : undefined,
          fontSize: filtered ? 20 : undefined
        }}
      />
    )
  };
};

export const getColumnDateRangeSearchProps = (column) => {
  const sortProps = column.sortable ? getColumnSortBaseProps() : {};
  return {
    ...sortProps,
    filterCondition: filterConditions.BETWEEN,
    filterDropdown: ({ setSelectedKeys, confirm }) => (
      <div style={{ padding: 8 }}>
        <RangePicker
          size="middle"
          format="DD-MM-YYYY"
          allowEmpty={[true, true]}
          onChange={(date, dateString) => {
            if (dateString && dateString[0] === '' && dateString[1] === '') {
              setSelectedKeys(undefined);
            } else {
              setSelectedKeys(dateString);
            }
            confirm();
          }}
        />
      </div>
    ),
    filterIcon: (filtered) => {
      return (
        <CalendarOutlined
          style={{
            color: filtered ? '@primary-color' : undefined,
            fontSize: filtered ? 20 : undefined
          }}
        />
      );
    }
  };
};

export const getColumnSortBaseProps = () => ({
  sorter: {
    compare: () => {},
    multiple: 1
  },
  showSorterTooltip: true
});

export const getColumnSearchBaseProps = (sortable) => {
  const sortProps = sortable ? getColumnSortBaseProps() : {};
  return {
    ...sortProps,
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '@primary-color' : undefined,
          fontSize: filtered ? 20 : undefined
        }}
      />
    )
  };
};

export const getColumnSearchEqProps = (sortable) => {
  const sortProps = sortable ? getColumnSortBaseProps() : {};
  return {
    ...sortProps,
    filterCondition: filterConditions.IN,
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '@primary-color' : undefined,
          fontSize: filtered ? 20 : undefined
        }}
      />
    )
  };
};

const FilterDropdown = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  label
}) => {
  const inputRef = React.useRef(null);

  React.useLayoutEffect(() => {
    inputRef.current.focus({
      cursor: 'start'
    });
  }, []);

  return (
    <div style={{ padding: 10 }}>
      <Input
        ref={inputRef}
        placeholder={`Buscar ${label}`}
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => {
          confirm();
        }}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => {
            confirm();
          }}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Buscar
        </Button>
        <Button
          onClick={() => clearFilters()}
          size="small"
          style={{ width: 90 }}
        >
          Limpiar
        </Button>
        {/* <Button
          type="link"
          size="small"
          onClick={() => {
            confirm({ closeDropdown: false });
          }}
        >
          Filtrar
        </Button> */}
      </Space>
    </div>
  );
};

export const getColumnSearchProps = (column) => ({
  ...getColumnSearchBaseProps(column.sortable),
  filterCondition: filterConditions.LIKE,
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) => (
    <FilterDropdown
      label={column.title}
      setSelectedKeys={setSelectedKeys}
      selectedKeys={selectedKeys}
      confirm={confirm}
      clearFilters={clearFilters}
    />
  )
});

export const getColumnNumericSearchProps = (column) => ({
  ...getColumnSearchBaseProps(column.sortable),
  filterCondition: filterConditions.EQUALS,
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) => (
    <FilterDropdown
      label={`${column.title} exacto`}
      setSelectedKeys={setSelectedKeys}
      selectedKeys={selectedKeys}
      confirm={confirm}
      clearFilters={clearFilters}
    />
  )
});

export const filterAseguradoras = async (empresa) => {
  const aseguradorsFilters = [];
  if (!empresa || empresa === null) {
    return [];
  }
  try {
    const aseguradoras = await getAseguradoras(empresa.id);
    Object.keys(aseguradoras).forEach(function test(key) {
      aseguradorsFilters.push({
        text: aseguradoras[key].aseguradora.nombre,
        value: aseguradoras[key].aseguradora.id
      });
    });
    return aseguradorsFilters;
  } catch (error) {
    // error
  }
  return [];
};

export const filterProductos = async (aseguradora) => {
  const productosFilters = [];
  if (!aseguradora || aseguradora === null) {
    return [];
  }
  try {
    const productos = await getProductos(aseguradora);
    Object.keys(productos).forEach(function test(key) {
      productosFilters.push({
        text: productos[key].producto.descripcion,
        value: productos[key].producto.id
      });
    });
    return productosFilters;
  } catch (error) {
    // error
  }
  return [];
};

export const filterPersonas = async (query, empresa) => {
  if (!empresa || empresa === null) {
    return [];
  }
  try {
    const personas = await getPersonas(query, empresa);
    return personas;
  } catch (error) {
    // error
  }
  return [];
};
